/** V2 liability (and shared asset) ownership helpers for 1003 / legacy views. */

export const normalizeOwnershipMode = (ownership, ownerPartyIds = []) => {
    const raw = `${ownership || ""}`.trim().toLowerCase()
    if (raw === "joint" || (Array.isArray(ownerPartyIds) && ownerPartyIds.length > 1)) {
        return "Joint"
    }
    return "Individual"
}

export const jointOthersSelected = (ownerPartyIds, currentPartyId) => (
    (ownerPartyIds || []).filter((id) => id && id !== currentPartyId)
)

export const ownershipPatch = (currentPartyId, ownership, selectedOthers = []) => {
    if (ownership === "Joint") {
        return {
            ownership: "Joint",
            ownerPartyIds: [currentPartyId, ...selectedOthers].filter(Boolean),
        }
    }
    return {
        ownership: "Individual",
        ownerPartyIds: currentPartyId ? [currentPartyId] : [],
    }
}

export const isIncompleteJointOwnership = (item, currentPartyId) => {
    if (!item) return false
    const mode = normalizeOwnershipMode(item.ownership, item.ownerPartyIds)
    if (mode !== "Joint") return false
    return jointOthersSelected(item.ownerPartyIds, currentPartyId).length === 0
}

export const listHasIncompleteJointOwnership = (items, currentPartyId) => (
    (items || []).some((item) => isIncompleteJointOwnership(item, currentPartyId))
)

export const assetsHaveIncompleteJointOwnership = (assets, currentPartyId) => (
    listHasIncompleteJointOwnership(assets?.accounts, currentPartyId)
    || listHasIncompleteJointOwnership(assets?.otherAssets, currentPartyId)
    || listHasIncompleteJointOwnership(assets?.gifts, currentPartyId)
)

export const liabilitiesHaveIncompleteJointOwnership = (liabilities, currentPartyId) => (
    listHasIncompleteJointOwnership(liabilities?.loans, currentPartyId)
)

/** Map credit-report Borrower|CoBorrower|Joint to V2 Individual/Joint + ownerPartyIds. */
export const mapCreditReportOwnershipToV2 = ({
    creditOwnership,
    ownerPartyId,
    primaryPartyId,
    cohabitingPartyId,
}) => {
    const raw = `${creditOwnership || ""}`.trim()
    if (raw === "Joint") {
        const owners = [...new Set([primaryPartyId, cohabitingPartyId].filter(Boolean))]
        if (owners.length >= 2) {
            return { ownership: "Joint", ownerPartyIds: owners }
        }
    }
    let partyId = ownerPartyId || primaryPartyId || ""
    if (raw === "Borrower") partyId = primaryPartyId || partyId
    else if (raw === "CoBorrower") partyId = cohabitingPartyId || partyId
    return {
        ownership: "Individual",
        ownerPartyIds: partyId ? [partyId] : [],
    }
}

/** Legacy 1003 / DTI expects creditliabilityShownOwnershipType (Borrower|CoBorrower|Joint). */
export const mapV2OwnershipToLegacyShownType = (item, primaryPartyId) => {
    const mode = normalizeOwnershipMode(item?.ownership, item?.ownerPartyIds)
    if (mode === "Joint") return "Joint"
    const owners = (item?.ownerPartyIds || []).filter(Boolean)
    if (owners.length === 1) {
        return owners[0] === primaryPartyId ? "Borrower" : "CoBorrower"
    }
    const raw = `${item?.ownership || ""}`.trim()
    if (raw === "Borrower") return "Borrower"
    if (raw === "CoBorrower") return "CoBorrower"
    return primaryPartyId && owners[0] === primaryPartyId ? "Borrower" : "CoBorrower"
}
